// extracted by mini-css-extract-plugin
module.exports = {"outerDiv":"DropdownItem_outerDiv__3MDBB","outerDivRounded":"DropdownItem_outerDivRounded__21hBp","img":"DropdownItem_img__23873","text":"DropdownItem_text__3TcUp"};